import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Usuario } from '../models/Usuario';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class UsuarioService {
    constructor(private http: Http) { }

    init() {

        return this.http.get('https://servicios.radiotaxiupar.com/public')
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                const res = response.json();
                return res;
            });
    }

    login(email: string, clave: string) {

        return this.http.post(environment.origin + '/usuario/autenticar', { email: email, clave: clave, rol: 2 })
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                const res = response.json();

                if (res.message === 'Correcto') {
                    const user = res.request;
                    if (user) {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('currentUser', JSON.stringify(user));
                    }
                }
                return res;
            });
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
    }

}



// WEBPACK FOOTER //
// ./src/app/servicios/usuario.service.ts